// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Head = require("next/head").default;

var make = Head;

exports.make = make;
/* make Not a pure module */
